import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  freeBetStore,
  userInfoStore,
  gameConfigStore,
  convertAmount,
  GameSection,
  GameStructure,
  isMobile,
  loadingStore,
  useSoundWatcher,
} from '@pascal/pascal-core';

import { HeaderWr } from './header';

import {
  AdditionalResponseCode,
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
} from '../enums/notifications';
import WebGameMain from '../game/web';
import { maxOddValue, MIN_ODD } from '../enums/constants';
import { gameDrawer } from '../game/drawers';

export const WebGame = observer(() => {
  const { activeFreeBet } = freeBetStore;
  const { currencySymbolOrCode } = userInfoStore;
  const {
    limits: { minBet, maxBet },
  } = gameConfigStore;
  useSoundWatcher();

  useEffect(() => {
    gameDrawer
      .execute({
        mode: isMobile() ? 'mobile' : 'web',
        scene: 'Main',
        prevScene: null,
      })
      .then(() => {
        loadingStore.updateLoading({ isPixiLoaded: true });
      });
  }, []);

  return (
    <GameStructure>
      <HeaderWr />
      <GameSection
        haveNotification
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        translationValues={{
          minBet: `${minBet} ${currencySymbolOrCode}`,
          maxBet,
          minOdd: `x${activeFreeBet.id ? activeFreeBet.minOdd : MIN_ODD}`,
          maxOdd: `x${convertAmount(maxOddValue)}`,
        }}
      >
        <WebGameMain />
      </GameSection>
    </GameStructure>
  );
});
